<template>
  <div class="fs-transform">
    <div class="fs-back">
      <router-link :to="'/transforms'" class="mi">arrow_back</router-link>
    </div>
    <div class="fs-actions-wrapper">
      <span class="fs-label">{{ $t('general.flip-and-rotate') }}</span>
      <ul class="fs-actions-menu">
        <li v-if="!transformConfig.lockFlip"><a @click.prevent="flip" class="mi">flip</a></li>
        <li v-if="!transformConfig.lockFlip"><a @click.prevent="flop" class="mi flop">flip</a></li>
        <li v-if="!transformConfig.lockRotation"><a @click.prevent="rotateLeft" class="mi">rotate_left</a></li>
        <li v-if="!transformConfig.lockRotation"><a @click.prevent="rotateRight" class="mi">rotate_right</a></li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Inject, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FsCanvas } from '@filestack/canvas-sdk';

@Component
class FlipAndRotate extends Vue {
  @Inject('canvas')
  public canvas: FsCanvas;

  @Getter('config')
  public config: any;

  get transformConfig() {
    return this.config('editor.transforms');
  }

  public async flip() {
    this.canvas.transform.flipX().then(() => {
      this.canvas.saveState('flipX');
    });
  }

  public flop() {
    this.canvas.transform.flipY().then(() => {
      this.canvas.saveState('flipY');
    });
  }

  public rotateRight() {
    this.canvas.transform.rotateRight().then(() => {
      this.canvas.saveState('rotateRight');
    });
  }

  public rotateLeft() {
    this.canvas.transform.rotateLeft().then(() => {
      this.canvas.saveState('rotateLeft');
    });
  }
}

export default FlipAndRotate;
</script>
